import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=18c2e47d&scoped=true"
import script from "./contacts.vue?vue&type=script&lang=js"
export * from "./contacts.vue?vue&type=script&lang=js"
import style0 from "./contacts.vue?vue&type=style&index=0&id=18c2e47d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c2e47d",
  null
  
)

export default component.exports